export default [
  {
    path: '',
    name: 'purchase return list',
    component: () => import('@/views/app/purchase-return/list/page-list.vue'),
    meta: { title: 'Daftar Retur Pembelian' },
  },
  {
    path: 'baru',
    name: 'purchase return create',
    component: () => import('@/views/app/purchase-return/create/page-create.vue'),
    meta: { title: 'Buat Retur Pembelian' },
  },
  {
    path: ':id/edit',
    name: 'purchase return edit',
    component: () => import('@/views/app/purchase-return/edit/page-edit.vue'),
    meta: { title: 'Edit Retur Pembelian' },
  },
  {
    path: ':id',
    name: 'purchase return detail',
    component: () => import('@/views/app/purchase-return/detail/page-detail.vue'),
    meta: { title: 'Detail Retur Pembelian' },
  },
]
